import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
let block = document.querySelector('.posts-preview');

if(block) {
    gsap.from('.tease-post > *', {
        scrollTrigger: {
            trigger: '.posts-wrapper',
            start: 'top 90%',
        },
        autoAlpha: 0,
        y: 15,
        duration: 0.5,
        stagger: 0.05,
        ease: 'power2.out'
    });
}